import { Box, styled } from '@mui/material';
import { APPROVAL_SECTION_GAP } from '@/components/Approval/@components/InfoSection';

/** 뒤에 HTML 본문이 이어지는 슬롯의 아래 여백 */
export const ContentSlotRoot = styled(Box)`
  margin-bottom: ${APPROVAL_SECTION_GAP}px;
`;
